// src/index.ts
var VERSION = "0.5.24";
export {
  VERSION
};
